import styled from "styled-components";
import { H3 } from "../../../../common";

export const ArticleTitle = styled(H3)`
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-bottom: 10px;
`;
